import { checkClientVersion } from '~/utils/clientConfig'

/** Shared by the launch plugin, Firebase bootstrap and the blocking screen. */
export function useNativeUpdate() {
  const floor = useState<string | null>('native-update-floor', () => null)
  const checking = useState('native-update-checking', () => false)

  async function retry() {
    if (checking.value) return
    checking.value = true
    try {
      // Preserve the old floor during retry: no game or Firebase flash.
      floor.value = await checkClientVersion(undefined, floor.value)
    } finally {
      checking.value = false
    }
  }

  return { floor, checking, retry }
}
